import PropTypes from "prop-types";
import * as React from "react";
import { useRecomendedShops } from "../../hooks";
import { useYouMightLike } from "../../hooks/useInfluencer";
import CheckoutRecommendations from "../Checkout/Recommendations";

export default function Recommendations({ route }) {
  const { influencers: recommendedShops } = useRecomendedShops({ route });
  const { influencers: youMightLike } = useYouMightLike({ route });

  return (
    <CheckoutRecommendations
      recommendedShops={recommendedShops}
      youMightLike={youMightLike}
    />
  );
}

Recommendations.propTypes = {
  route: PropTypes.string.isRequired,
};
